import React from "react";
import { Send, Copy, MessageCircle, Loader2, X } from "lucide-react";
import { apiKirimLinkNota, formatApiErrorDetail } from "@/lib/api";

// G1-E: copy or send (wa.me, from the cashier's own WhatsApp) the links of
// one invoice: digital nota, customer page, tracking.
export default function KirimLink({ notaId, testid = "kirim-link" }) {
  const [open, setOpen] = React.useState(false);
  const [d, setD] = React.useState(null);
  const [msg, setMsg] = React.useState(null);
  const [busy, setBusy] = React.useState(false);

  const buka = async () => {
    if (open) return setOpen(false);
    setOpen(true);
    setBusy(true);
    setMsg(null);
    try {
      setD(await apiKirimLinkNota(notaId));
    } catch (e) {
      setD(null);
      setMsg(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };
  const salin = async (teks, label) => {
    try {
      await navigator.clipboard.writeText(teks);
      setMsg(`${label} disalin`);
    } catch {
      setMsg(teks);
    }
  };

  const rows = d
    ? [["Nota digital", d.nota_url, "nota"], ["Cek status & tagihan", d.customer_url, "customer"], ["Lacak produksi", d.tracking_url, "tracking"]]
    : [];

  return (
    <span className="inline-flex flex-col gap-2 text-xs" data-testid={testid}>
      <button
        type="button"
        onClick={buka}
        data-testid={`${testid}-buka`}
        className="inline-flex items-center gap-1.5 self-start rounded border border-emerald-500/40 px-2 py-1 text-emerald-300 hover:bg-emerald-500/10"
      >
        {open ? <X size={12} /> : <Send size={12} />} Kirim link ke customer
      </button>
      {open && (
        <span className="block rounded-lg border border-slate-700 bg-slate-950/70 p-3 space-y-2 min-w-[16rem]" data-testid={`${testid}-panel`}>
          {busy && <Loader2 size={14} className="animate-spin text-slate-400" />}
          {rows.map(([label, url, k]) => (
            <span key={k} className="flex items-center justify-between gap-3">
              <span className="text-slate-400">{label}</span>
              {url ? (
                <button type="button" data-testid={`${testid}-salin-${k}`} onClick={() => salin(url, `Link ${label.toLowerCase()}`)}
                  className="inline-flex items-center gap-1 rounded border border-slate-600 px-2 py-0.5 text-slate-200 hover:border-amber-500/50">
                  <Copy size={11} /> Salin
                </button>
              ) : (
                <span className="text-slate-600">{k === "nota" ? "dicabut Owner" : "tidak ada"}</span>
              )}
            </span>
          ))}
          {d && (
            <span className="flex flex-wrap gap-2 pt-1 border-t border-slate-800">
              {d.wa_url ? (
                <a href={d.wa_url} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-wa`}
                  className="inline-flex items-center gap-1 rounded bg-emerald-500 px-2.5 py-1 font-semibold text-slate-950 hover:bg-emerald-400">
                  <MessageCircle size={12} /> Kirim WA
                </a>
              ) : (
                <span data-testid={`${testid}-tanpa-wa`} className="text-amber-300">Nomor WA customer kosong / tidak valid.</span>
              )}
              <button type="button" data-testid={`${testid}-salin-pesan`} onClick={() => salin(d.pesan, "Pesan")}
                className="inline-flex items-center gap-1 rounded border border-slate-600 px-2 py-1 text-slate-200 hover:border-amber-500/50">
                <Copy size={11} /> Salin pesan
              </button>
            </span>
          )}
          {msg && <span className="block text-slate-400 break-all" data-testid={`${testid}-msg`}>{msg}</span>}
        </span>
      )}
    </span>
  );
}
